/* ============
 * Mutations for the account module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import { FIND, RESET, MERCHANTS, SELECTED_MERCHANT } from './mutation-types'

export default {
  [FIND] (state, account) {
    state.id = account.id
    state.email = account.email
    state.firstName = account.firstName
    state.lastName = account.lastName
    state.avatar = account.avatar
    state.algoliaKey = account.algoliaKey
    state.merchants = account.merchants
    state.merchantLocations = account.merchantLocations
  },

  [MERCHANTS] (state, merchants) {
    state.merchants = merchants
  },

  [SELECTED_MERCHANT] (state, merchant) {
    state.selectedMerchant = merchant
  },

  [RESET] (state) {
    state.id = null
    state.email = null
    state.firstName = null
    state.lastName = null
    state.avatar = null
    state.algoliaKey = null
    state.merchants = []
    state.merchantLocations = []
    state.selectedMerchant = null
  }
}



// WEBPACK FOOTER //
// ./src/app/store/modules/account/mutations.js